import { render, staticRenderFns } from "./PopupCouponGuide.vue?vue&type=template&id=f2a12886&"
import script from "./PopupCouponGuide.vue?vue&type=script&lang=ts&"
export * from "./PopupCouponGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports